import { useInView } from '@/hooks/useInView';

export default function PotentialSection() {
  const { ref, inView } = useInView();

  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="bg-white py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className={`text-center mb-14 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-yellow-500 mb-3">Child's Potential</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 font-syne mb-3">
            We reveal the child's potential
          </h2>
          <p className="text-gray-500">Learning that <strong className="text-gray-900">sparks interest</strong></p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 items-start">
          {/* Video */}
          <div className={`flex-1 w-full transition-all duration-700 delay-100 ${inView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}>
            <div className="relative w-full rounded-2xl overflow-hidden bg-black" style={{ paddingBottom: '56.25%' }}>
              <iframe
                className="absolute inset-0 w-full h-full"
                src="https://www.youtube.com/embed/GPvFeaqlvRI?rel=0"
                title="Nanit Inclusive learning video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>

          {/* Points */}
          <div className={`flex-1 flex flex-col gap-6 transition-all duration-700 delay-200 ${inView ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`}>
            {[
              { title: 'Kids explore STEM', body: 'Through hands-on learning, they see results instantly, make mistakes without fear and stay naturally curious.' },
              { title: 'The goal is', body: 'To build confidence, inspire a love for learning and develop basic engineering skills through hands-on experience.' },
            ].map((item) => (
              <div key={item.title} className="flex items-start gap-4 p-6 bg-gray-50 rounded-2xl border border-gray-100">
                <img
                  src="https://kids.nanitrobot.com/wp-content/themes/nanit/assets/images/checkmark_ellipse.svg"
                  alt=""
                  className="w-8 h-8 flex-shrink-0 mt-0.5"
                />
                <p className="text-gray-700 text-sm leading-relaxed">
                  <strong className="text-gray-900">{item.title}</strong> {item.body}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Banner */}
        <div className={`mt-16 relative overflow-hidden rounded-3xl bg-yellow-400 p-10 md:p-14 flex flex-col md:flex-row items-center justify-between gap-8 transition-all duration-700 delay-300 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="absolute -right-10 -top-10 w-48 h-48 rounded-full bg-yellow-300/50"></div>
          <div className="absolute -left-6 -bottom-6 w-32 h-32 rounded-full bg-yellow-500/30"></div>
          <div className="relative flex items-center gap-6">
            <img src="https://kids.nanitrobot.com/wp-content/themes/nanit/assets/images/free-video.svg" alt="" className="w-16 h-16 flex-shrink-0" />
            <p className="text-2xl md:text-3xl font-extrabold text-gray-900 max-w-sm leading-snug font-syne">
              Give every child the opportunity to become an engineer of the future
            </p>
          </div>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="relative bg-gray-900 text-white font-bold px-8 py-4 rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer text-sm flex-shrink-0"
          >
            Registration
          </a>
        </div>
      </div>
    </section>
  );
}
